import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import { GET_FLITER_ID, showAddAccountAlertNew } from '../../../../../../utils';
import InputField from '../Elements/InputField';
import CheckBoxField from '../Elements/CheckboxField';
import NeedHelp from '../Elements/NeedHelp';
import { isAppleSafari } from '../../../../../../utils';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import AccountPicker from '../Elements/AccountPicker';
import { createFeedAction } from '../../../../../../actions/addFeedActions';
import { addUserAccount } from '../../../../../Authorization/SocialAuth/connectSocialAcc';
import AccountSelect from '../Tiktok/components/AccountSelect';
import ConnectNetwork from '../Elements/ConnectNetwork';
import InfoSection from '../Elements/InfoSection';


const channel = isAppleSafari() ? window : new BroadcastChannel('connect');

const NETWORK_ID = 32;
const initialErrors = {
    hashtagError: false,
    handleError: false,
    keywordError: false
}
class Thread extends Component {
    state = {
        hashtag: "",
        handle: "",
        keyword: "",
        manuallyApprove: false,
        ...initialErrors,
        filterType: 'Keyword',
        filterId: 1,
        connetedAccount: null,
        loading: false,
        errorMsg: 'This field is required',
    }

    componentDidMount() {
        this.props.onFilterNameChange(this.state.filterType);
        channel.addEventListener("message", this.readAuthenticationCode);
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, [`${e.target.name}Error`]: false });
    onManuallyApproveChange = (value) => this.setState({ manuallyApprove: value });
    onConnectedAccountChange = (value) => this.setState({ connetedAccount: value });

    onAddAccount = () => showAddAccountAlertNew({ id: NETWORK_ID, name: 'Threads' }, "addFeed");

    onSubmit = () => {
        const { hashtag, handle, filterId, connetedAccount, keyword } = this.state;

        const errorFields = {
            [1]: 'keywordError',
            [2]: 'hashtagError',
            [3]: 'handleError'
        };
        const errorField = errorFields[filterId];
        if (!this.state[errorField] && !(hashtag || handle || keyword)) {
            this.setState({ [errorField]: true });
        } else {
            if (connetedAccount == null) this.onAddAccount();
            else this.onAddFeed(null);
        }
    }

    onAddFeed = (connectAccountId) => {
        const { hashtag, handle, keyword, manuallyApprove, filterId, connetedAccount } = this.state
        const { navigation, hideAddfeed, wallId } = this.props
        var obj = {
            wallId,
            feedText: '',
            filter: filterId,
            networkId: NETWORK_ID,
            moderation: manuallyApprove,
            accountId: connectAccountId || connetedAccount,
        }
        if (filterId == 1) obj['feedText'] = keyword;
        else if (filterId == 2) obj['feedText'] = hashtag.split('#').join('');
        else if (filterId == 3) obj['feedText'] = handle.split('@').join('');
        this.setState({ loading: true, ...initialErrors });

        createFeedAction(obj, NETWORK_ID, (feedId) => this.setState({ loading: false }, () => {
            if (feedId) {
                navigation(`/moderation/index/${wallId}`);
                hideAddfeed();
            }
        }));
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId, type } = response;
        if (type == "addFeed") addUserAccount(networkId, data, (accountId) => this.onAddFeed(accountId), localStorage.getItem('ownerId'))
    }

    componentWillUnmount() {
        channel.removeEventListener("message", this.readAuthenticationCode);
    }

    render() {
        const { hashtag, handle, errorMsg, manuallyApprove, hashtagError, handleError, filterType, connetedAccount, loading, keyword, keywordError } = this.state
        const { feedInfo, connectedAcc } = this.props

        return (
            <div className="form-body create_feed_wt">
                <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details createFeedInsta personalizePopup">
                    <Tabs defaultActiveKey="Keyword" id="PinterestFeedTab" value={filterType} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3" onSelect={e => this.setState({ filterType: e, filterId: GET_FLITER_ID(e, feedInfo) }, () => this.props.onFilterNameChange(e))}>
                        <Tab eventKey={'Keyword'} className="nav-link className= p-0" title={<span>{'Keyword'}</span>}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-font`}></i>
                                        </span>
                                    </div>
                                    <InputField name={"keyword"} id='thread_keyword' autoComplete={true} className={`autosearch mycheck form-control`} placeholder="Enter keyword" value={keyword} onChangeHandler={this.onTextChange} />
                                </div>
                                {keywordError ? <span id="thread_keyword_error" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                            <div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_keyword" />
                                </div>
                            </div>

                            {connectedAcc?.length ? <AccountPicker connectedAcc={connectedAcc} networkId={NETWORK_ID} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                            <InfoSection text={'Initially 35 posts will be aggregated after which all the upcoming posts will be aggregated.'} />
                        </Tab>
                        {/* <Tab eventKey={'Topic Tag'} className="nav-link className= p-0" title={<span>{'Topic Tag'}</span>}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-hashtag`}></i>
                                        </span>
                                    </div>
                                    <InputField name={"hashtag"} id='thread_hashtag' autoComplete={true} className={`autosearch mycheck form-control`} placeholder="Enter Topic Tag" value={hashtag} onChangeHandler={this.onTextChange} />
                                </div>
                                {hashtagError ? <span id="thread_hashtag_error" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                            <div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_hashtag" />
                                </div>
                            </div>

                            {connectedAcc?.length ? <AccountPicker connectedAcc={connectedAcc} networkId={NETWORK_ID} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                            <InfoSection text={'Initially 35 posts will be aggregated after which all the upcoming posts will be aggregated.'} />
                        </Tab> */}
                        <Tab eventKey={'Handle'} className="nav-link className= p-0" title={<span>{'Handle'}</span>}>
                            <div className="form-group">
                                <div className="input-group">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text">
                                            <i className={`fas fa-at`}></i>
                                        </span>
                                    </div>
                                    <InputField name={"handle"} id='thread_handle' autoComplete={true} className={`autosearch mycheck form-control`} placeholder="Enter user handle" value={handle} onChangeHandler={this.onTextChange} />
                                </div>
                                {handleError ? <span id="thread_handle_error" className="errorMessage required">{errorMsg}</span> : null}
                            </div>
                            <div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                </div>
                            </div>

                            {connectedAcc?.length ? <AccountPicker connectedAcc={connectedAcc} networkId={NETWORK_ID} onConnectedAccountChange={this.onConnectedAccountChange} connetedAccount={connetedAccount} /> : null}
                            <InfoSection text={'Initially 35 posts will be aggregated after which all the upcoming posts will be aggregated.'} />
                        </Tab>
                        <Tab eventKey={'My Handle'} className="nav-link className= p-0" title={<span>{'My Handle'}</span>}>
                            {(connectedAcc?.length > 0) ? <><AccountSelect connectedAcc={connectedAcc} onConnectedAccountChange={this.onConnectedAccountChange} /><div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                </div>
                            </div><InfoSection text={'Initially 35 posts will be aggregated after which all the upcoming posts will be aggregated.'} /></> : <ConnectNetwork id={NETWORK_ID} name={"Threads"} />}
                        </Tab>
                        <Tab eventKey={'Mentions'} className="nav-link className= p-0" title={<span>{'Mentions'}</span>}>
                            {(connectedAcc?.length > 0) ? <><AccountSelect connectedAcc={connectedAcc} onConnectedAccountChange={this.onConnectedAccountChange} /><div className="hideforBSearch">
                                <div className="checkbox-inline">
                                    <CheckBoxField isChecked={manuallyApprove} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                </div>
                            </div><InfoSection text={'Initially 35 posts will be aggregated after which all the upcoming posts will be aggregated.'} /></> : <ConnectNetwork id={NETWORK_ID} name={"Threads"} />}
                        </Tab>
                    </Tabs>
                </div>
                <div className="form-actions w-100">
                    <div className="f-between flex-wrap border-top pt-3 mt-4">
                        <NeedHelp text={'Need help in adding feeds?'} videoUrl={''} supportLink={''} />
                        <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={loading} />
                    </div>
                </div>
            </div>
        )
    }
}

export default Thread;